<h2 mat-dialog-title>Confirm change on non-default organisation</h2>
<mat-dialog-content>
  <p>
    You are about to change <strong>{{ data.feature }}</strong> for:
  </p>

  <div class="org-summary">
    <strong>{{ data.orgName }}</strong>
    <span class="org-summary__id">({{ data.orgId }})</span>
  </div>

  <p class="warn-note">
    <strong>This is not the Qupil organisation.</strong>
    The change will only affect <strong>{{ data.orgName }}</strong>'s
    operators and end-users. Continue?
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="warn" (click)="confirm()">
    Save change to {{ data.orgName }}
  </button>
</mat-dialog-actions>
